import { Request } from './Request';

export class LeaveTeamRequest extends Request<never> {
  method = 'DELETE';
  url = '/tc/tmemberleave';
}
